<template>
    <section id="home-about" class="home-about bg-primary color-white">
        <!-- <div class="container px-0"> -->
            <div class="home-about-wrapper">
                <div class="about-image-wrapper">
                    <div class="about-image" data-aos="fade-in" @click="showVideo">
                        <img v-if="imageUrl" class="lazy blur lazyload" :src="thumbnail" :data-src="imageUrl"
                            :alt="title" />

                        <div class="image-overlay"></div>
                        <button type="button" class="btn-play">
                            <span v-if="isActive" class="material-symbols-outlined">pause</span>
                            <span v-else class="material-symbols-outlined">play_arrow</span></button>
                    </div>
                </div>

                <div class="home-about-content">
                    <div class="home-about-logo" v-if="logoUrl">
                        <img class="lazy blur lazyload" :src="thumbnail" :data-src="logoUrl" :alt="title" width="400"
                            height="125" />
                    </div>
                    <div class="home-about-message">
                        <h1 class="about-title" data-aos="fade-up" data-aos-duration="400">{{ title }}</h1>
                        <div class="about-description" data-aos="fade-up" data-aos-duration="800" v-html="description"></div>
                    </div>
                </div>
            </div>
        <!-- </div> -->
    </section>

</template>

<script>
export default {
    props: ['thumbnail', 'videoUrl', 'imageUrl', 'logoUrl', 'title', 'description'],
    data() {
        return {
            isActive: false,
            isStart: false,
        }
    },
    computed: {
        active() {
            return this.$store.getters.homeAboutPopVideo
        },
    },
    watch: {
        active(response) {
            this.isActive = response
        }
    },
    methods: {
        showVideo() {
            this.$store.dispatch('setHomeAboutPopVideo', this.videoUrl)
        },
    }
}
</script>

<style lang="scss" scoped>
.about-image {
    position: relative;

    &:hover {
        .image-overlay {
            background-color: rgba(0, 0, 0, .5);
        }

        .btn-play {
            background-color: rgba(0, 0, 0, .7);
        }

    }
}

.image-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, .3);
}

.btn-play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    background-color: transparent;
    border: 0;

    height: 96px;
    width: 96px;


    display: flex;
    justify-content: center;
    align-items: center;


    span {
        font-size: 72px;
        color: #fff;
    }

}

@media screen and (min-width: 768px) {

    .btn-play span {
        transform: scale(0.8);
        transition: transform 0.2s ease;
    }

    .about-image:hover {

        .btn-play span {
            transform: scale(1.0)
        }
    }

    .about-title{
        text-align: center;
    }
}

@media screen and (min-width: 1400px) {

    .home-about-message{
        padding: 48px;
    }
    .about-title{
        font-size: 68px;
    }

    .about-description{
        font-size: 28px;
    }
}
</style>